import React from 'react';
import Menu from '../components/Navbar';


const Architecture = () => {
    return (
        <>
            <Menu />
        </>
    )
}

export default Architecture